import { createSystem, defaultConfig, defineConfig } from '@chakra-ui/react'

/**
 * Modernist design system tokens (see the design handoff's `_ds/modernist-.../styles.css`).
 * Ramps are generated in OKLCH on one shared lightness scale; the base accent
 * `#ec3013` sits between the 500 and 600 ramp steps and is only ~3:1 on the
 * ground, so small accent-colored text must use `accent.700`.
 */
const config = defineConfig({
  theme: {
    tokens: {
      colors: {
        ink: { value: '#201e1d' },
        ground: { value: '#f3f2f2' },
        surface: { value: '#eae9e9' },
        accent: {
          DEFAULT: { value: '#ec3013' },
          100: { value: '#fff2ef' },
          200: { value: '#ffe0d9' },
          300: { value: '#ffc4b8' },
          400: { value: '#ff9783' },
          500: { value: '#ff563c' },
          600: { value: '#dd2b0f' },
          700: { value: '#ae1800' },
          800: { value: '#7c1405' },
          900: { value: '#4d170e' },
        },
        neutral: {
          100: { value: '#f8f4f4' },
          200: { value: '#eae7e7' },
          300: { value: '#d7d3d3' },
          400: { value: '#bab6b6' },
          500: { value: '#9b9797' },
          600: { value: '#7d7979' },
          700: { value: '#605d5d' },
          800: { value: '#444141' },
          900: { value: '#2d2b2b' },
        },
      },
      fonts: {
        heading: { value: "'Archivo', system-ui, sans-serif" },
        body: { value: "'Archivo', system-ui, sans-serif" },
      },
      radii: {
        sm: { value: '0px' },
        md: { value: '0px' },
        lg: { value: '0px' },
      },
    },
    semanticTokens: {
      colors: {
        bg: { DEFAULT: { value: '{colors.ground}' } },
        fg: { DEFAULT: { value: '{colors.ink}' } },
        divider: { value: 'rgba(32, 30, 29, 0.4)' },
        muted: { value: 'rgba(32, 30, 29, 0.55)' },
        /** 2px rules drawn on the accent poster field. */
        dividerOnAccent: { value: 'rgba(243, 242, 242, 0.45)' },
      },
    },
  },
})

export const system = createSystem(defaultConfig, config)
